import { render, staticRenderFns } from "./CustomerDashLocations.vue?vue&type=template&id=5ae00203&scoped=true"
import script from "./CustomerDashLocations.vue?vue&type=script&lang=js"
export * from "./CustomerDashLocations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae00203",
  null
  
)

export default component.exports